export function resolveAppElapsedMs(input: {
  readonly startedAtMs: number;
  readonly nowMs: number;
  readonly accumulatedPausedMs?: number;
  readonly pausedAtMs?: number | null;
}): number {
  const effectiveNowMs = input.pausedAtMs ?? input.nowMs;
  return effectiveNowMs - input.startedAtMs - (input.accumulatedPausedMs ?? 0);
}

export function formatAppElapsed(ms: number): string {
  const totalSec = Math.max(0, Math.floor(ms / 1000));
  const sec = totalSec % 60;
  const min = Math.floor(totalSec / 60) % 60;
  const hour = Math.floor(totalSec / 3600);
  const mm = String(min).padStart(2, "0");
  const ss = String(sec).padStart(2, "0");
  return hour > 0 ? `${hour}:${mm}:${ss}` : `${mm}:${ss}`;
}
